// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"0b58ce02","141":"fdf4e5a9","167":"9927056a","195":"7c6d9188","209":"7a797c6e","358":"b960da54","372":"9d2e283b","478":"52363f65","562":"282cb56f","678":"9adf9cb5","844":"db8330d1","922":"950c5cf1","957":"584928e3"}[chunkId] + ".chunk.js";
};